export const API_URL = process.env.PORTALS_API_URL
export const SSO_URL = process.env.SSO_URL
export const SESSIONS_URL = process.env.PORTALS_SESSIONS_API_URL
export const FILEPROXY_URL = process.env.FILEPROXY_URL
export const VOTIRO_URL = 'https://ib8vz9s7f0.execute-api.eu-central-1.amazonaws.com/dev'
